// initial state
const state = () => ({
  showRoomsList: true,
  showMatchedTab: false,
  messageInputFocused: false,
});

// getters
const getters = {
  getShowRoomsList: state => {
    return state.showRoomsList;
  },
  getShowMatchedTab: state => {
    return state.showMatchedTab;
  },
  getMessageInputFocused: state => {
    return state.messageInputFocused;
  },
};

// actions
const actions = {};

// mutations
const mutations = {
  setShowRoomsList: (state, val) => {
    state.showRoomsList = val;
  },
  setShowMatchedTab: (state, val) => {
    state.showMatchedTab = val;
  },
  setMessageInputFocused: (state, val) => {
    state.messageInputFocused = val;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
